angular.module('zc.masterApi')

.factory "MasterProjectSegmentCookie", ($resource, $q, BaseProjectCrudService) ->
  class MasterProjectSegmentCookie extends BaseProjectCrudService

  new MasterProjectSegmentCookie(
    $resource
    $q
    "/api/master/projects/:projectId/segment_cookies/:id"
    "segment_cookie"
    "segment_cookies"
  )




// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/api/segment_cookie.service.coffee